import React from 'react';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isAudio } from 'helpers/AppHelper';
import { pubPath } from 'helpers/AppHelper';
import { getDuration } from 'helpers/FieldHelper';
import { getMediaUrl } from 'helpers/FileHelper';
import * as ConfigTypes from 'config/ConfigTypes';


import './MediaBox.scss';

const getThumbUrl = (props) => {

    let imgSrc = `${pubPath()}/img1.jpg`;
    // let random = Math.round(Math.random() * 5);
    // let imgSrc = `${pubPath()}/thumbnails/DK_Website_Personenarchiv_Platzhalter_0${random}.jpg`;
    console.log("LAMTEST RANDOM THUMBNAIL", imgSrc);
    if (props.clip.mainthumbnail && props.clip.mainthumbnail.url) {
        imgSrc = `https:${props.clip.mainthumbnail.url}&width=750&height=420`
    } else if (isAudio()) imgSrc = `${pubPath()}/audio.png`;
    return imgSrc;
}

const showSliderThumb = (props) => {
    if (isAudio()) return <div></div>
    let alt = "";
    if (props.clip && props.clip.title) alt = props.clip.title
    return (
        <div className="custom-mediabox">
            <img src={getThumbUrl(props)} alt={alt} />
            {/* <div className="custom-mediabox-info">
                <span className="custom-mediabox-play">
                    <FontAwesomeIcon icon={faPlay} />
                </span>
                <span className="custom-mediabox-duration">{getDuration(props)}</span>
            </div> */}
        </div>
    )
}

const MediaBox = props => {
    if (props.isthumb) return showSliderThumb(props)
    if (props.clip.mediafiles && props.clip.mediafiles.elements[0]
        && props.clip.mediafiles.elements[0].url) {
        if (isAudio()) return <div></div>;
        return (
            <div className="custom-mediabox">
                {/* <video controls autoPlay={props.isAutoplay} tabIndex="0"
                    controlsList="nodownload volume" id={`video_${props.clip.id}`}>
                    <source src={getMediaUrl(props.clip.mediafiles.elements, props, ConfigTypes.VIDEO)} type="video/mp4" />
                </video> */}
            </div>
        )
    }
    return (<div></div>)
}

export default MediaBox;